import type { Configuration } from "../config";
import { defaults } from "./defaults";

const configuration: Configuration = {
  ...defaults,
  shop: {
    instance: "EU",
    countries: [
      "AT",
      "BE",
      "BG",
      "CY",
      "CZ",
      "DE",
      "DK",
      "EE",
      "ES",
      "FI",
      "FR",
      "GR",
      "HR",
      "HU",
      "IE",
      "IT",
      "LT",
      "LU",
      "LV",
      "MT",
      "NL",
      "PT",
      "PL",
      "RO",
      "SE",
      "SI",
      "SK",
    ],
    url: "https://eu.alpinewhite.com",
    lang: { main: "de", enabled: ["de", "en", "fr", "pl"] },
    newsletter: true,
    sections: {
      shop: true,
      treatments: true,
    },
    partners: [
      "CH_BENU",
      "AT_BIPA",
      "CH_Coop",
      "CH_CoopVitality",
      "DACH_Douglas",
      "DACH_Flaconi",
      "CH_Galaxus",
      "CH_HaarShop",
      "DACH_LYKO",
      "CH_Manor",
      "CH_PerfectHair",
      "DE_Rossmann",
      "CH_Rotpunkt",
      "CH_ZurRose",
      "AT_DM",
      "DACH_ShopApotheke",
      "PL_SuperPharm",
      "DACH_Zalando",
      "DACH_Luxplus",
      "FL_Stockmann",
      "PL_DOZ",
      "PL_EuroVaistine",
      "PL_Gemini",
    ],
    scripts: {
      gtm: "GTM-P3K8685",
      facebook: "421631559015965",
      tiktok: "D36197RC77UBR5UJRO70",
      pinterest: "2613981124848",
      klaviyo: "Y4J68d",
      skimLinks: "243839X1727274",
    },
    stamped: {
      apiKeyPublic: "pubkey-fk9z7i163WWw69Yf7lRb4ukSg27Fd0",
      storeUrl: "shop.alpinewhite.eu",
    },
    shopifyClient: {
      domain: "shopeu.alpinewhite.com",
      accessToken: "668605c2340f1e5c4e0f5c1419a36d1c",
      shopId: "gid://shopify/Shop/25202851903",
      storefrontId: "1000114675",
    },
    meta: {
      de: {
        title: "Alpine White | Teeth Whitening Strips | Bleaching ",
        description:
          "Selbst für ein strahlendes Lächeln sorgen. Alpine White bietet ein komplettes Set für Reinigung, Bleaching und Pflege. Entdecke unsere Whitening Strips.",
        keywords: ["Whitening Strips", "Whitestrips", "Bleaching", "Homebleaching", "Whitening Kit", "Zahnpflege"],
      },
      en: {
        title: "Alpine White | Teeth Whitening Strips | Bleaching",
        description:
          "Give yourself a radiant smile with white teeth. Alpine White provides a complete kit for cleaning, bleaching and care. Discover our Whitening Strips.",
        keywords: [
          "Whitening Strips",
          "Whitestrips",
          "Bleaching",
          "Homebleaching",
          "Whitening Kit",
          "Dental Care",
          "White Teeth",
        ],
      },
      fr: {
        title: "Alpine White | Strips Blanchiment Dentaire | Blanchiment ",
        description:
          "Retrouvez un sourire rayonnant et des dents blanches. Alpine White propose une série de produits pour le nettoyage, le blanchiment et le soin des dents.",
        keywords: [
          "Kit Blanchiment Dentaire",
          "Blanchiment",
          "Bandes Blanchissantes",
          "Whitening Strips",
          "Soin Dentaire",
        ],
      },
      pl: {
        title: "Alpine White | Paski Wybielające Zęby | Wybielanie",
        description:
          "Zapewnij sobie promienny uśmiech z białymi zębami. Alpine White oferuje kompletny zestaw do czyszczenia, wybielania i pielęgnacji. Odkryj nasze paski wybielające.",
        keywords: [
          "Paski Wybielające",
          "Wybielanie Zębów",
          "Wybielanie",
          "Domowe Wybielanie",
          "Zestaw do Wybielania",
          "Pielęgnacja Zębów",
          "Białe Zęby",
        ],
      },
    },
  },
};

export { configuration };
